export interface GenericRequest<T> {
  userGuid: string;
  userId: string;
  companyCode: string;
  pageRecordCOUNT: number;
  pageSize: number;
  isAcending: boolean;
  sortColumn: string;
  companyGuid: string;
  requestData: T; // Generic Type
}




export class LoginModel {

  userGuid: string = "F8064B66-A103-4F5A-8964-186E2B0B5C8D";
  userId: string = "0";
  companyCode: string = "";
  pageRecordCount: number = 1000;
  pageSize: number = 1;
  isAcending: boolean = true;
  sortColumn: string = "MenuName";
  companyGuid?: string | null = "418DCDA6-7E91-43AF-AEF5-7F2BE4A9ECF1";
  requestData: string | loginRequestData | roleRequestData | ReVerifyRequest | secuirtyloginRequestData | Array<RequestData> | null = "";
}



export class LoginReqPayload {
  ModuleSecret: string = "";
  ModuleId: string = "";
  UserName: string = "";
  UserPassword: string = "";
}

export class ReVerifyReqPayload {
  GUID: string = "";
  AUTHTOKEN: string = "";
  MODULEID: string = "";
  MODULESECRET: string = "";
  REDIRECTURL: string = "";
}

export class ReVerifyRequest {
  ReqMessage: string = "";
  LoginDate: string = "";
}


export class loginRequestData {
  ReqMessage: string = ""
  loginDate: string = "";
}

export class secuirtyloginRequestData {
  ServiceLayerUrl: string = ""
  CompanyDB: string = "";
  UserName:string="";
  Password:string="";
  ManagerUserName=""; 
  UseSAP=true;

  


 
//for local run   when user for sap user and containes \\in username
 // IsCloudOnPremise=true;

  //when b1 online user will be maintined in separate file and that is not linked with sap
 // IsCCC=false;
}

export class roleRequestData {
  roleGuId: string | null = null;
   roleTypeGuId: string | null = null;
  roleCode: string = "";
  roleName: string = "";
  remarks: string = "";
  isActive: boolean = false;
  delMark: boolean = false;
}

export class RequestData {
  Key: string = "";
  Value: string = "";
  OperatorType: string = "";
}
